export const REM = 10;
export const REM_IN_VW = 1;
export const REM_MIN = 10;
export const REM_MAX = 10;

export const FONT_NAME = 'Maison Neue';

export const FONT_FAMILY = `"${FONT_NAME}", Arial, Helvetica, sans-serif`;
// export const FONT_FAMILY = `Arial, Helvetica, sans-serif`;

export const FONT_SIZE_PX = 21;
export const FONT_SIZE = FONT_SIZE_PX / REM;

export const FONT_SIZE__SMALL_PX = 14;
export const FONT_SIZE__SMALL = FONT_SIZE__SMALL_PX / REM;

export const LINE_HEIGHT_PX = 26;
export const LINE_HEIGHT = LINE_HEIGHT_PX / REM;

export const LETTER_SPACING = 0.5 / REM;
